export default function CircularLeftArrow({ style }) {
    return (
        <svg style={style} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.00004 11.204C1.00005 5.79386 5.4773 0.999999 11.0001 1C16.523 1 3.53906 4.5 3.99998 11.204C4.50929 18.612 15.6895 21 10.1667 21C4.64385 21 1.00004 16.6141 1.00004 11.204Z" fill="#83CFA4"/>
        <ellipse cx="11" cy="11.2041" rx="10" ry="9.79592" transform="rotate(-180 11 11.2041)" stroke="#536987" strokeWidth="1.5"/>
        <path d="M14.5 16.1016L9.5 11.2036L14.5 6.30564" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>        
    );
  }
  